import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import RightSideMenuProvider from "components/RightSideMenuProvider";
import RightSideMenuDealer from "components/RightSideMenuDealer";
import RightSideMenuAdmin from "components/RightSideMenuAdmin";

import MyAdsProvider from "components/MyAdsProvider";
import MyAdsDealer from "components/MyAdsDealer";
import DashboardMenu from "components/DashboardMenu";
import ProjectRoutes from "./Routes";
import LeftMenuNotificationsDealerDashboard from "components/LeftMenuNotificationsDealerDashboard";
import MyOffersCountersDealer from "components/MyOffersCountersDealer";
import NotificationsBell from "components/NotificationsBell";

const EMPTY_COUNTERS = { all: 0, noOffers: 0, pending: 0, approved: 0, archive: 0 };

const EMPTY_DEALER_COUNTERS = {
  ads_all: 0,
  ads_new: 0,
  ads_archive: 0,
  ads_pending: 0,
  offers_new: 0,
  offers_approved: 0,
  cars_auction: 0,
  bundles_auction: 0,
};

function safeJSONParse(str, fallback) {
  try {
    return str ? JSON.parse(str) : fallback;
  } catch {
    return fallback;
  }
}


function App() {
  const location = useLocation();
  const navigate = useNavigate();

  const isRootPath = location.pathname === "/";

  const hideLeftMenu = useMemo(() => {
    return (

      location.pathname.startsWith("/recived-offers") ||
      location.pathname === "/dashboard-dealer" ||
      location.pathname === "/dashboard-provider" ||
      location.pathname === "/my-offers" ||
      /^\/dashboard-provider\/\d+$/.test(location.pathname) ||
      /^\/(provider-cars|dealer-cars)\/\d+$/.test(location.pathname)
    );
  }, [location.pathname]);

  const [adCounters, setAdCounters] = useState(EMPTY_COUNTERS);

  const [dealerCounters, setDealerCounters] = useState(() => {
    const stored = localStorage.getItem("dealerCounters");
    return safeJSONParse(stored, EMPTY_DEALER_COUNTERS);
  });

  const [currentUser, setCurrentUser] = useState(() => {
    const stored = localStorage.getItem("currentUser");
    return safeJSONParse(stored, null);
  });

  useEffect(() => {
    localStorage.setItem("dealerCounters", JSON.stringify(dealerCounters));
  }, [dealerCounters]);

  useEffect(() => {
    if (currentUser) localStorage.setItem("currentUser", JSON.stringify(currentUser));
    else localStorage.removeItem("currentUser");
  }, [currentUser]);

  const handleLogout = () => {
    localStorage.removeItem("currentUser");
    localStorage.removeItem("userName");
    setCurrentUser(null);
    navigate("/", { replace: true });
  };
const userType = Number(currentUser?.user_type);
console.log("currentUser:", currentUser);
console.log("userType:", userType, "typeof:", typeof currentUser?.user_type);

  return (
    <>
      <ProjectRoutes
        currentUser={currentUser}
        setCurrentUser={setCurrentUser}
        setGlobalCounters={setAdCounters}
        setDealerCounters={setDealerCounters}
      />

      {/* 🔔 פעמון – לא בדף לוגין */}
      {!isRootPath &&
        currentUser &&
        (userType === 2 || userType === 3) && (
          <NotificationsBell currentUser={currentUser} />
        )}

      {/* כל הסיידברים לא בדף לוגין */}
      {!isRootPath && (
        <>
          {userType === 2 ?  (
            <RightSideMenuProvider handleLogout={handleLogout} currentUser={currentUser} />
          ) : userType === 3 ? (
            <RightSideMenuDealer handleLogout={handleLogout} currentUser={currentUser} />
          ) : null}

          {!hideLeftMenu && currentUser && (
            userType === 2 ? (
              <MyAdsProvider counters={adCounters} />
            ) : userType === 3 ? (
              <MyAdsDealer counters={dealerCounters} />
            ) : null
          )}

          { userType === 3 && location.pathname.includes("/my-offers") && (
            <MyOffersCountersDealer counters={dealerCounters} />
          )}

          {location.pathname.includes("/dashboard-dealer") && currentUser && (
            <>
              <DashboardMenu currentUser={currentUser} counters={dealerCounters} />
              <LeftMenuNotificationsDealerDashboard currentUser={currentUser} />
            </>
          )}

          {/* Admin Sidebar */}
          {currentUser?.user_type === 1 && (
            <RightSideMenuAdmin currentUser={currentUser} handleLogout={handleLogout} />
          )}
        </>
      )}
    </>
  );
}

export default App;
